import { render, staticRenderFns } from "./DetalhesPedido.vue?vue&type=template&id=26dfe8d8&scoped=true&"
import script from "./DetalhesPedido.vue?vue&type=script&lang=js&"
export * from "./DetalhesPedido.vue?vue&type=script&lang=js&"
import style0 from "./DetalhesPedido.vue?vue&type=style&index=0&id=26dfe8d8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26dfe8d8",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
installComponents(component, {VBtn,VCard})


/* hot reload */
if (module.hot) {
  var api = require("D:\\Trabalho\\Lupa Soluções em TI\\Clientes\\Leonardo Raton\\Site\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('26dfe8d8')) {
      api.createRecord('26dfe8d8', component.options)
    } else {
      api.reload('26dfe8d8', component.options)
    }
    module.hot.accept("./DetalhesPedido.vue?vue&type=template&id=26dfe8d8&scoped=true&", function () {
      api.rerender('26dfe8d8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pages/Checkout/components/detallhesPedido/DetalhesPedido.vue"
export default component.exports